interface IProps {
  designation: string;
  tier: string;
  data: Array<{
    icon: string;
    descriptions: string[];
  }>;
}

function RolesBasedResponsibilities({ designation, tier, data }: IProps) {
  return (
    <>
      <div className="text-lg font-semibold mb-4">
        Roles & Responsibilities for{' '}
        <span className="text-[#3C91E6]">
          {designation} (Tier {tier})
        </span>
      </div>
      {data.length > 0 ? (
        <div className="grid grid-cols-2 gap-4">
          {data.map((item, index) => (
            <div
              key={index}
              className="flex items-center gap-3 p-4 border rounded-lg"
            >
              <img src={item.icon} alt="" className="w-10 h-10" />
              <div className="flex flex-col">
                {item.descriptions.map((desc, descIndex) => (
                  <div key={descIndex} className="flex items-center">
                    <span className="w-1.5 h-1.5 bg-gray-400 rounded-full mr-2" />
                    {desc}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-gray-400 italic p-4 text-center border rounded-lg">
          No roles and responsibilities data available
        </div>
      )}
    </>
  );
}

export default RolesBasedResponsibilities;
